<script lang="ts" setup>
import type { StoreStockStatusFragment } from '#graphql-operations'

const emit = defineEmits(['showStoreStock'])

export interface Props {
  editable?: boolean
}

const { editable = false } = defineProps<Props>()

const { items } = useCart()

const filteredItems = computed(() =>
  items.value,
)

const showStoreStock = (data: StoreStockStatusFragment | undefined) => {
  emit('showStoreStock', data)
}
</script>

<template>
  <div
    v-if="items"
    class="cart__products"
  >
    <CartLine
      v-for="item in filteredItems"
      :key="item.id"
      :item="item"
      :editable="editable"
      @show-store-stock="showStoreStock"
    />
  </div>
</template>
